import { jsx as _jsx } from "react/jsx-runtime";
import { TableRowStyled } from './ItemWorkflowTableRow.styled';
const ItemWorkflowTableRow = (props) => {
    return _jsx(TableRowStyled, { ...props });
};
export { ItemWorkflowTableRow };
